import { FrontendFlagsQuery } from './frontend-flags-query';
import { ModifyFrontendFlagsMutation } from './modify-frontend-flags-mutation';
export var endpoints = {
    frontendFlagsQuery: new FrontendFlagsQuery(),
    modifyFrontendFlagsMutation: new ModifyFrontendFlagsMutation(),
};
